import React from "react";
import classNames from "classnames";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import { TariffsLayout as MicroMarkupTariffsLayout } from "Layouts/MicroMarkup";
import { TariffsTable } from "ComponentsUI/TariffsTable";
import { TariffsHeaderRow } from "ComponentsUI/TarifficationC";

const useStyles = createUseStyles((theme) => ({
	rootWrapper: {
		width: "100%",
		marginBottom: "50px",
	},
	presenceBrand: {
		marginBottom: 0,
	},
}));

const TarificationCWrapper = ({ text, tariffs, presenceBrand, skipLayout, children }) => {
	const classes = useStyles();
	const tableHeader = <TariffsHeaderRow text={text} skipLayout={skipLayout} />;
	return (
		<Container>
			<MicroMarkupTariffsLayout tariffs={tariffs}>
				<TariffsTable tableHeader={tableHeader}>
					<div
						className={classNames(classes.rootWrapper, {
							[classes.presenceBrand]: presenceBrand,
						})}
					>
						{children}
					</div>
				</TariffsTable>
			</MicroMarkupTariffsLayout>
		</Container>
	);
};

export default TarificationCWrapper;
